import {config} from '../config';
import {getAuthStorage, getSessionToken, getVendorId} from './authSession';

const ONBOARDING_BASE = `${config.API_MWSVENDORONBOARDING_BASE_URL}/microstores`;

export const STORE_INFO_EVENT = 'vendorProfileCached';

export const formatLocation = (d = {}) => {
	const line1 = d.addressLine1 || '';
	const line2 = d.addressLine2 || '';
	const city = d.city || '';
	const pin = d.postalCode || '';
	return [
		line1,
		line2 ? (line1 ? `, ${line2}` : line2) : '',
		city ? (line2 ? `, ${city}` : city) : '',
		pin ? (city ? ` - ${pin}` : pin) : '',
	].join('');
};

export const readCachedStoreInfo = () => {
	const store = getAuthStorage();
	return {
		name: store.getItem('businessName') || '',
		location: store.getItem('businessLocation') || '',
	};
};

export const cacheStoreInfo = ({name, location}) => {
	const store = getAuthStorage();
	if (name) store.setItem('businessName', name);
	if (location) store.setItem('businessLocation', location);
	window.dispatchEvent(new CustomEvent(STORE_INFO_EVENT, {
		detail: {businessName: name || '', businessLocation: location || ''},
	}));
};

/** Fetches the vendor profile and caches name/location. Returns the info or null on failure. */
export const refreshStoreInfo = async () => {
	const vendorId = getVendorId();
	const sessionToken = getSessionToken();
	if (!vendorId || !sessionToken) return null;
	try {
		const res = await fetch(`${ONBOARDING_BASE}/vendorProfile/${vendorId}`, {
			headers: {'X-Session-Token': sessionToken},
		});
		const json = await res.json().catch(() => ({}));
		if (!res.ok || json?.statusCode !== 200 || !json?.data) return null;
		const info = {
			name: String(json.data.businessName || ''),
			location: formatLocation(json.data),
		};
		cacheStoreInfo(info);
		return info;
	} catch {
		return null;
	}
};
